import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=ba8b35d8&scoped=true"
import script from "./WordCloud.vue?vue&type=script&lang=js"
export * from "./WordCloud.vue?vue&type=script&lang=js"
import style0 from "./WordCloud.vue?vue&type=style&index=0&id=ba8b35d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b35d8",
  null
  
)

export default component.exports